import { connect } from 'react-redux';
import ProductSelect from './ProductSelect';
import productActions from '../../../../actions/products';
import {
  setVariantsQuantity,
  setSelectedLocation,
  setSelectedResource,
} from '../../../../actions/orders';
import { setConfiguration, setTimeZone } from '../../../../actions/settings';
import { customSelectStyles } from '../../../../utilities/helperUtility';

export default connect(
  ({
    product, settings, order,
  }) => ({
    product: product.data,
    settings,
    selectedResource: order.selectedResource,
    selectedLocation: order.selectedLocation,
    optionsStyles: settings.style ? settings.style.button : null,
    selectStyles: customSelectStyles(settings.style ? settings.style.select : null),
    bodyStyle: settings.style ? settings.style.body : null,
    onTrigger: window.xprops ? window.xprops.onTrigger : null,
  }),
  (dispatch) => ({
    fetchProduct: (product) => dispatch(productActions.fetchProduct(product)),
    setConfiguration: (settings) => dispatch(setConfiguration(settings)),
    setSelectedLocation: (location) => dispatch(setSelectedLocation(location)),
    setSelectedResource: (resource) => dispatch(setSelectedResource(resource)),
    setTimeZone: (timezone) => dispatch(setTimeZone(timezone)),
    setVariantsQuantity: (name) => dispatch(setVariantsQuantity(name, 1, { singleVariant: true })),
  }),
)(ProductSelect);
